import { IDepartmentSearchPathInfo } from '../../interface';
import { lang } from '@umu/ukit-lang';
import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import { classSet } from '@umu/umu-dom';
import { Dropdown, Iconfont, Menu } from '@umu/umu-design';
import { useInViewport } from 'ahooks';
import IfShow from '../ifShow';
import { components } from 'common';
import './index.scss';
import uniq from 'lodash/uniq';

interface IProps {
    list: IDepartmentSearchPathInfo[];
    onSelectItem?: (id: string, isRoot?: boolean) => void;
}
interface IPathItemInfoProps {
    className?: string;
    suffix?: string | JSX.Element;
    info: IDepartmentSearchPathInfo;
    onClick: () => void;
    onHideCallback?: () => void;
}
const { If } = components;

const PathItemInfo = (props: IPathItemInfoProps) => {
    const { className, info, suffix = '', onClick, onHideCallback } = props;
    const ref = useRef<HTMLSpanElement>(null);
    const [_inViewport, ratio = 0] = useInViewport(ref);
    useEffect(() => {
        if (ratio < 1) {
            onHideCallback && onHideCallback();
        }
    }, [ratio]);
    return (
        <Fragment>
            <span ref={ref} className={className} onClick={onClick}>
                {info.name}
            </span>
            {suffix}
        </Fragment>
    );
};
function PathList(props: IProps) {
    const { list, onSelectItem } = props;
    const [isShowMore, setIsShowMore] = useState(false);
    const [hideSpanMap, setHideSpanMap] = useState<{ [key: string]: boolean }>({});
    const refP = useRef<HTMLParagraphElement>(null);
    const renderList = useCallback(() => {
        return list.map((item, index) => {
            const isLast = index === list.length - 1;
            return (
                <PathItemInfo
                    key={`${item.id}-path-item`}
                    className={classSet({
                        'path-item': true,
                        'organize-item-active': !isLast,
                    })}
                    onClick={() => onSelectItem && onSelectItem(item.id)}
                    onHideCallback={() => {
                        console.log('hide', item.id);
                        setHideSpanMap({ ...hideSpanMap, [item.id]: true });
                    }}
                    info={item}
                    suffix={!isLast ? <span className="comment-search-index-path-list-item">/</span> : ''}
                />
            );
        });
    }, [list]);
    useEffect(() => {
        if (refP.current) {
            const isOverflow = refP.current.scrollHeight > refP.current.clientHeight;
            setIsShowMore(isOverflow);
        }
    }, [list]);
    const renderOverlay = () => {
        const showList = uniq(list.filter((item) => hideSpanMap[item.id])).map((item) => {
                return {
                    key: item.id,
                    title: item.name,
                };
            });
        return (
            <Menu
                popupClassName="comment-search-index-path-list-dropdown-menu"
                list={showList}
                onClick={({ key }) => {
                    onSelectItem && onSelectItem(key);
                }}
            />
        );
    };
    return (
        <div className="comment-search-index-path-list">
            <div className="organize-path">
                <div className="department-search-organize-icon-circle" />
            </div>
            <p ref={refP} className="organize-path-paragraph">
                <span
                    className={classSet({
                        'path-root path-item': true,
                        'organize-item-active': list.length > 0,
                    })}
                    onClick={() => onSelectItem && onSelectItem('0', true)}
                >
                    {lang('组织架构')}
                </span>
                <If condition={list.length > 0}>
                    <span className="comment-search-index-path-list-item">/</span>
                </If>
                {renderList()}
            </p>
            <IfShow condition={isShowMore}>
                <Dropdown
                    expandConfig={{
                        trigger: ['click'],
                    }}
                    placement={'bottomRight' as any}
                    overlayClassName="comment-search-index-path-list-dropdown"
                    overlay={renderOverlay()}
                >
                    <div className="show-more-list">
                        <Iconfont type="UprightMore" className="icon-arrow-right" />
                    </div>
                </Dropdown>
            </IfShow>
        </div>
    );
}

export default PathList;
